import { Controller } from "@hotwired/stimulus"

// Swaps the server-computed pretty filter path into the address bar.
export default class extends Controller {
  static values = { path: String }

  connect() {
    if (!this.pathValue) return

    const current = window.location.pathname + window.location.search
    if (current !== this.pathValue) history.replaceState({ turbo: {}, ...history.state }, "", this.pathValue)
  }
}
